<template>
  <div>
    <van-nav-bar title="我的考勤申诉" left-text="返回" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
      <template slot="right">
        <van-icon name="edit" size="25"/>
      </template>
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        :immediate-check="false"
        @refresh="onRefresh"
        @load="onLoad">
        <van-swipe-cell v-for="item in list" :key="item.id" disabled>
          <van-card :tag=item.statusToString
                    :title=title(item.createUserName)
                    class="goods-card"
                    @click="jumpToApplyPage(item.status, item.taskId, item.processInstanceId, item.appNo, item.processDefinitionId)">
            <template slot="thumb">
              <img :src="listIcon" style="width: 80px;"/>
            </template>
            <template slot="tags">
              <span>单位：{{ item.createDeptName }}</span><br>
              <span>变更日期：{{ item.changeDate }}</span><br>
              <span>原因：{{ item.reason }}</span><br>
            </template>
            <template slot="footer">
              <div>{{ item.createTime }}</div>
            </template>
          </van-card>

          <template slot="right">
            <van-button square text="删除" type="danger" class="delete-button"/>
          </template>
        </van-swipe-cell>
      </van-list>
      <van-empty description="暂无数据" v-if="emptyShow"/>
    </van-pull-refresh>
  </div>
</template>

<script>
import {Toast} from "vant";
import {isLogin, isWechat} from "../../../utils/util";

export default {
  name: "list",
  data() {
    return {
      list: [],
      listIcon: "../../../static/images/holiday_apply.png",
      loading: false,
      finished: false,
      refreshing: false,
      userId: '',
      userClassify: 0,
      userGroup: 0,
      refereeStatus: 0,
      finishedText: "上滑加载更多...",
      emptyShow: false,
      size: 10,
      current: 1,
      total: 0,
      modelKey: "UserAttenceErrAppeal",
      processDefinitionId: '',
      processInstanceId: '',
      appNo: '',
      workOvertimeStatusList: [],
      workOvertimeTypeList: [],
      userInfo: {},
    };
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.loading = true;
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.userInfo = user;
          this.getAttenceErrList();
        }
      );
    },
    toAttenceErrApply() {
      this.$fetch("/attence-api/blade-flow/process/getFlowProcessByKey", {
        modelKey: this.modelKey,
      }).then(
        res => {
          const data = res.data;
          let bladeFlow = {
            taskDefinitionKey: "apply",
            processDefinitionId: data.id,
            processDefinitionKey: this.modelKey,
          };
          this.$bodyPost("/attence-api/blade-flow/process/startProcessApply", bladeFlow).then(
            res => {
              const data = res.data;
              Toast(res.msg);
              this.$router.push({
                path: "/attenceflow/userAttenceErrAppeal/form",
                query: {
                  taskId: data.taskId,
                  processInstanceId: data.processInstanceId,
                  appNo: data.appNo,
                  processDefinitionId: data.processDefinitionId,
                  pageType: 1,
                }
              });
            }
          );
        }
      );
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      } else {
        this.current++;
      }
      this.getAttenceErrList();
    },
    dictionaryInit() {
      this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
        code: 'workovertime_status'
      }).then(res => {
        const data = res.data;
        this.workOvertimeStatusList = data;
        this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
          code: 'workovertime_type'
        }).then(res => {
          const data = res.data;
          this.workOvertimeTypeList = data;
          this.getAttenceErrList();
        });
      });
    },
    workOvertimeStatusFormatter(status) {
      let formateName = "";
      this.workOvertimeStatusList.forEach((item) => {
        if (status == item.dictKey) {
          formateName = item.dictValue;
        }
      });
      return formateName;
    },
    workOvertimeTypeFormatter(type) {
      let formateName = "";
      this.workOvertimeTypeList.forEach((item) => {
        if (type == item.dictKey) {
          formateName = item.dictValue;
        }
      });
      return formateName;
    },
    onRefresh() {
      // 清空列表数据
      this.current = 1;
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getAttenceErrList: function () {
      this.$fetch("/attence-api/blade-flow/process/userAttenceErrAppeal/list", {
        current: this.current,
        size: this.size,
        createUser: this.userInfo.id,
        descs: 'CREATE_TIME',
      }).then(
        res => {
          const data = res.data;
          this.list = this.list.concat(data.records);
          this.total = data.total;
          this.size = data.size;
          this.current = data.current;
          if (this.list.length > 0) {
            this.emptyShow = false;
            if (this.total > this.list.length) {
              this.finishedText = "上滑加载更多...";
            } else {
              // 数据全部加载完成
              this.finished = true;
              this.finishedText = "没有更多了";
            }
          } else {
            this.emptyShow = true;
            this.finished = true;
            this.finishedText = "";
          }
          // 加载状态结束
          this.loading = false;
          console.log("返回的数据：" + JSON.stringify(this.list));
        },
        error => {
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          this.finished = true;
        }
      );
    },
    onClickRight: function () {
      this.toAttenceErrApply();
    },
    onClickLeft: function () {
      this.$router.push({
        path: "/attenceflow/AttenceHome",
        query: {}
      });
    },
    holidayDesc(beginTime, endTime, day) {
      return "开始时间：" + beginTime + "，结束时间：" + endTime + "，请假天数：" + day;
    },
    title(name, deptName, empNo) {
      return "申请人：" + name;
    },
    jumpToApplyPage(status, taskId, processInstanceId, appNo, processDefinitionId) {
      if (status == 0) {
        let bladeFlow = {
          processDefinitionId: processDefinitionId,
          processInstanceId: processInstanceId,
          appNo: appNo,
          processDefinitionKey: this.modelKey,
        };
        this.$bodyPost("/attence-api/blade-flow/process/startProcessApply", bladeFlow).then(
          res => {
            const data = res.data;
            Toast(res.msg);
            this.$router.push({
              path: "/attenceflow/userAttenceErrAppeal/form",
              query: {
                taskId: data.taskId,
                processInstanceId: data.processInstanceId,
                appNo: data.appNo,
                processDefinitionId: data.processDefinitionId,
                pageType: 1,
              }
            });
          }
        );
      } else {

      }
    }
  },
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

.goods-card {
  margin: 0;
  background-color: @white;
}

.delete-button {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/userAttenceErrAppeal/list.vue